<style>

/* Modal Content */
.modal-content {
	background-color: #ffffff;
	margin: auto;
	padding: 20px;
	border: 1px solid #888;
    display: flex;
    justify-content: center;
    max-width: 800px;
    border-radius: 4px;
}

.modal-header {
	text-align: center;
	font-family: Montserrat;
}

/* The Close Button */
.close {
 color: rgb(0, 0, 0);
 float: left;
 font-size: 28px;
 font-weight: bold;
}

.close:hover,
.close:focus {
 color: #000;
 text-decoration: none;
 cursor: pointer;
}


.user_input {
position: relative;
margin: 0 auto;	
/* width: 300px; */
height: min-content;
width: 100%;
}

.wrapper {
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    padding: 0 1rem;
    width: 100%;
    height: 100%;
    z-index: 100;
    background: rgba(0, 0, 0, 0.39);
    justify-content: center;
    align-items: center;
}

textarea {
    height: 150px;
    max-width: 95%;
    width: 90%;
    border-radius: 3px;
    margin: 0.8rem;
}
form {
    width: 100%;
    padding: 0;
}

</style>
<script>
    export let open = true
    export let name
    export let description = ""
    let err
    let loading = false
    export let updateDesc = (description) => {}
    async function updateDescWrapper() {
        try {
            console.log(description)
            loading = true
            await updateDesc(description)
            loading = false
        } catch (e) {
            console.error(e)
            err = e
        }
    }
</script>
<div class="wrapper">
    <div class="modal-content">
        <span on:click ="{() => open = false}" class="close">&times;</span>
        <div class="modal-header">Change Your {name || "Location"}'s Description</div>
        <div class="user_input">
            <form>
                <textarea type="text" id="text_descripton" bind:value={description} />
                <button on:click="{() => updateDescWrapper()}" class="main {loading ? 'loading' : ''}">Update Description</button>
            </form>
            {#if err}
                {err}
            {/if}
        </div>
    </div>
</div>